export interface GdprReportStatus {
  availableUntil: number;
  id: number;
  ready: boolean;
  requestDate: number;
}

export interface GdprReport {
  asOfDate: string;
  data: string;
  displayName?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  secondLastName?: string | null;
}

export function isGdprReport(object: any): object is GdprReport {
  return (<GdprReport>object).data !== undefined;
}
